// Initialize a global array to store the product handles
var currentProductHandles = [];
// Bumped on every popup build so a superseded build's in-flight card fetches stop appending.
var crossSellBuildId = 0;
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (this.form) {
          this.variantIdInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');
  
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
          this.hideErrors = this.dataset.hideErrors === 'true';
        }

      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        //cross-sell-popup product data updating based on product metafileds

        const giftAtc = evt.target.closest('.free-gift-addtocart');
        const rotGiftAtc = evt.target.closest('.rot_free-gift-addtocart');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        //this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        
        /**bulk buy**/
        let quantityQuickView;
        const selectedBulkBuy = document.querySelector('.main-bulk-buy .bulk-buy-inner:not(.hidden) input[name="bulk_buy_qty"]:checked');
        if (selectedBulkBuy) {
          quantityQuickView = selectedBulkBuy.closest('label').dataset.qty;
        }
        let currentQuantity = null;
        const isMainBuyButton = this.submitButton.classList.contains('main_buy_button');
        // Each buy button reads its own stepper: the sticky strip sits outside <product-info>,
        // so a document-wide lookup let its value override the picked multipack.
        const stickyStrip = this.submitButton.closest('.main-add-to-basket');
        const quantityScope = stickyStrip || this.closest('product-info') || this;
        const quantityInput = quantityScope.querySelector('.price_quantity_wrapper .quantity__input');

        const bulkBuyWrapper = document.querySelector('.main-bulk-buy');
        const bulkBuyVisible = !!(
          bulkBuyWrapper &&
          (bulkBuyWrapper.offsetWidth || bulkBuyWrapper.offsetHeight || bulkBuyWrapper.getClientRects().length)
        );
        const resolveQuantity = () => {
          const stepped = parseInt(quantityInput?.value, 10);
          if (stickyStrip) return stepped > 0 ? stepped : 1;
          if (stepped > 1) return stepped;
          if (bulkBuyVisible && quantityQuickView) return quantityQuickView;
          return quantityInput?.value || quantityQuickView || 1;
        };

        // XVD 
        const mainAddToBasketContainer = document.querySelector('.main-add-to-basket');
        const bulk_buy_utm_parameter = this.submitButton.classList.contains('bulk_buy_utm_parameter');
        const isInsideMainAddToBasket = this.submitButton.closest('.main-add-to-basket') !== null;

        const xvdStored = sessionStorage.getItem('xvd_found');
        let quantity = 1; // default fallback

        if (isMainBuyButton) {
          if (bulk_buy_utm_parameter) {
            // If xvd parameter was stored in session, disable bulk logic
            if (xvdStored === 'true') {
              quantity = quantityInput?.value || quantityQuickView || 1;
            } else {
              if(isInsideMainAddToBasket){
                quantity = resolveQuantity();
              } else {
                quantity = quantityQuickView || 1;
              }
            }
          } else {
            quantity = resolveQuantity();
          }

          currentQuantity = quantity;
          const productForm = this.submitButton.closest('product-form');

          if (productForm) {
            const hiddenInput = productForm.querySelector('.updated-product-quantity');
            if (hiddenInput) {
              hiddenInput.value = quantity;
              formData.set('quantity', hiddenInput.value);
            } 
          } 
        }

        // Cart page has no cart-drawer/notification but does have <cart-items>.
        // When present, an add from the "customers also bought" section should
        // re-render the cart in place instead of opening the cross-sell popup.
        const cartItemsEl = this.cart ? null : document.querySelector('cart-items');

        // cart-drawer.js is a lazy-script: calling this on a not-yet-upgraded element threw
        // before the fetch, so .finally() never reset the button.
        const cartReady = !!this.cart && typeof this.cart.getSectionsToRender === 'function';

        try {
          if (cartReady) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          } else if (cartItemsEl) {
            formData.append(
              'sections',
              cartItemsEl.getSectionsToRender().map((section) => section.section)
            );
            formData.append('sections_url', window.location.pathname);
          }
        } catch (e) {
          // Add without sections rather than strand the button.
          console.error('Add to cart: section prep failed', e);
        }

        if (giftAtc && !rotGiftAtc) {
          formData.append('properties[_gift]', 'true');
          formData.append('properties[_auto]', 'true');
          formData.append('properties[_d_gift]', 'false');
          formData.append('properties[_gift_uid]', Date.now().toString());
        }

        if (rotGiftAtc) {
          const rotBar =
            document.getElementById('rotating-gift-bar') ||
            document.getElementById('rotating-gift-data');
          const rotCampaignId = rotBar?.dataset.rotCampaignId || '';
          formData.append('properties[_gift]', 'true');
          formData.append('properties[_rotational_freebie]', 'true');
          formData.append('properties[_rotational_period]', rotCampaignId);
          formData.append('properties[_gift_uid]', Date.now().toString());
        }

        config.body = formData;

        // Popup opens on click, not after the add. "page" cart type only, never gift adds.
        const showCrossSell =
          !this.cart &&
          !giftAtc &&
          !rotGiftAtc &&
          !cartItemsEl &&
          this.submitButton.getAttribute('data-handles') &&
          document.getElementById('upsell-product-list') &&
          typeof crossSellPopup === 'function';
        if (showCrossSell) crossSellPopup(this.submitButton);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              //this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.error = false;

              // On the cart page (<cart-items> present) the add comes from the
              // "customers also bought" section. Re-render the cart in place —
              // NO cross-sell popup and NO full page refresh.
              if (cartItemsEl) {
                try {
                  cartItemsEl.getSectionsToRender().forEach((section) => {
                    const sectionEl = document.getElementById(section.id);
                    const rendered = response.sections && response.sections[section.section];
                    if (!sectionEl || !rendered) return;
                    const elementToReplace = sectionEl.querySelector(section.selector) || sectionEl;
                    elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(rendered, section.selector);
                  });
                  // The cart-icon-bubble section is re-rendered in the loop above,
                  // so the header count updates without relying on response.item_count
                  // (which /cart/add.js does not return).
                } catch (err) {
                  console.error('Cart-page reco add re-render failed:', err);
                }

                // Keep freebie / rotating-gift logic and the reco carousel in sync.
                if (typeof window.handleGiftProduct === 'function') {
                  fetch('/cart.js').then((r) => r.json()).then((c) => window.handleGiftProduct(c)).catch(() => {});
                }
                if (typeof window.handleRotatingGift === 'function') {
                  fetch('/cart.js').then((r) => r.json()).then((c) => window.handleRotatingGift(c)).catch(() => {});
                }
                if (typeof window.initializeCarousel === 'function') window.initializeCarousel();

                // Notify subscribers with source 'cart-items' so <cart-items> doesn't refetch again.
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'cart-items',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
                return;
              }

              // Popup already opened on click — just sync the count.
              if (showCrossSell) {
                this.syncCartBubble();
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (!cartReady) {
                      window.location = window.routes.cart_url;
                      return;
                    }
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (!window.location.pathname.includes('/cart')) {
                if (cartReady) {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                } else {
                  // No drawer to paint — show the cart instead.
                  window.location = window.routes.cart_url;
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!rotGiftAtc) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner')?.classList.add('hidden');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Replaces only the bubble's inner HTML so we never nest a duplicate
      // #cart-icon-bubble inside itself.
      syncCartBubble() {
        fetch(window.location.pathname, { headers: { Accept: 'text/html' } })
          .then((r) => r.text())
          .then((html) => {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-icon-bubble');
            if (!fresh) return;
            document.querySelectorAll('#cart-icon-bubble').forEach((el) => {
              el.innerHTML = fresh.innerHTML;
            });
          })
          .catch(() => {});
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          //this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

async function crossSellPopup(submitButton) {
  const buildId = ++crossSellBuildId;
  const clickedProductTitle = submitButton.getAttribute('data-title');
  const clickedProductDescription = submitButton.getAttribute('data-description');
  const clickedProductImage = submitButton.getAttribute('data-product-image');
  const metaFieldProductHandles = submitButton.getAttribute('data-handles');

  if (metaFieldProductHandles) {
    const productHandles = metaFieldProductHandles.split(',').map(item => item.trim()).filter(item => item !== "");
    let cartHandles = [];

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const handles = cart.items.map(item => item.handle);
      cartHandles = handles.join(',');
    } catch (error) {
      console.error('Error fetching cart:', error);
    }

    const filteredProductHandles = productHandles.filter(handle => !cartHandles.includes(handle));
    currentProductHandles = filteredProductHandles;

    const upsellProductList = document.getElementById('upsell-product-list');
    // The popup markup isn't rendered on the cart template — bail out rather than throw
    // on a null container. The cart page has its own add flow (no popup by design).
    if (!upsellProductList) return;
    let crossSellItems = [];

    const createProductCard = (productUrl, index) => {
      const card = document.createElement('li');
      card.classList.add('owl-slide', 'slider-item');

      fetch(productUrl)
        .then(response => response.text())
        .then(data => {
          if (buildId !== crossSellBuildId) return; // a newer build owns the list now
          card.innerHTML = data;

          // Grab product data from rendered card button and push to crossSellItems
          const btn = card.querySelector('[data-product-handle]');
          if (btn) {
            crossSellItems.push({
              brand:    btn.getAttribute('data-brand') || '',
              category: btn.getAttribute('data-item_category2') || btn.getAttribute('data-item_category3') || '',
              id:       btn.getAttribute('data-master_id') || '',
              name:     btn.getAttribute('data-prod_name') || '',
              position: index + 1,
              price:    btn.getAttribute('data-price')?.replace(/[^0-9.,]/g, '').replace(',', '.') || '',
              variant:  '',
            });
          }

          upsellProductList.appendChild(card);
          const currentLength = currentProductHandles.length;
          card.classList.add(`card-length-${currentLength}`);
          initializeCrossSellCarousel();
        })
        .catch(error => {
          console.error('Error fetching product card:', error);
        });
    };

    upsellProductList.innerHTML = '';

    currentProductHandles.forEach((handle, index) => {
      const productUrl = `/products/${handle}?view=card`;
      createProductCard(productUrl, index);
    });

    if (currentProductHandles.length > 0) {
      const checkIfCardsAdded = setInterval(() => {
        if (buildId !== crossSellBuildId) {
          clearInterval(checkIfCardsAdded);
          return;
        }
        const upsellProductList = document.getElementById('upsell-product-list');
        if (upsellProductList && upsellProductList.children.length > 0) {
          const mainPopupCard = document.querySelector('.main-popup-card');
          if (mainPopupCard) {
            mainPopupCard.classList.remove('hidden');
            document.querySelector('body').classList.add('cross-sell-open');
          }
          clearInterval(checkIfCardsAdded);
        }

        let productPopupTitle = document.querySelector('.product-popup-title');
        let productSubheadingDescription = document.querySelector('.product-subheading-description');
        let productfeaturedImage = document.querySelector('.cross-sell-product-featured');
        if (productPopupTitle) {
          productPopupTitle.innerText = clickedProductTitle;
        }
        if (productSubheadingDescription) {
          productSubheadingDescription.innerText = clickedProductDescription;
        }
        if (productfeaturedImage) {
          productfeaturedImage.src = clickedProductImage;
        }
      }, 100);
    } else {
      const mainPopupCard = document.querySelector('.main-popup-card');
      if (mainPopupCard) {
        document.querySelector('body').classList.remove('cross-sell-open');
        mainPopupCard.classList.add('hidden');
      }
    }
  } else {
    const mainPopupCard = document.querySelector('.main-popup-card');
    if (mainPopupCard) {
      document.querySelector('body').classList.remove('cross-sell-open');
      mainPopupCard.classList.add('hidden');
    }
  }
}


// Cross cell popup close
var crossPopupCloseButton = document.querySelector('#close-popup');
var continueShopping = document.querySelector('.continue-shopping_button');
var crossSellModal = document.querySelector('.main-popup-card');
var overlay = document.querySelector('.cross-cell-main-overlay');

function closeModal() {
  crossSellModal?.classList.add('hidden');
  document.querySelector('body').classList.remove('cross-sell-open', 'overflow-hidden');
}
// Close popup on clicking the close button
crossPopupCloseButton?.addEventListener('click', function() {
  closeModal()
});
continueShopping?.addEventListener('click', function(){
  closeModal()
})
// Close popup when clicking outside of the modal or overlay
document.addEventListener('click', (event) => {
  if (event.target.classList.contains('cross-cell-outer-container')) {
     closeModal()
  }
});

function initializeCrossSellCarousel() {
  // Destroy the existing carousel and reinitialize it
  if ($('.cross-cell-products-owl-carousel').data('owl.carousel')) {
      $('.cross-cell-products-owl-carousel').trigger('destroy.owl.carousel');
  }

  // Initialize the Owl Carousel
  $('.cross-cell-products-owl-carousel').owlCarousel({
      loop: true,
      nav: true,
      margin: 10,
      responsive: {
          0: {
            items: 1.5,
            dots: false,
            margin: 20,
            nav: false,
          },
          600: {
            items: 2,
            dots: false,
            margin: 20,
            nav: false,
          },
          768: {
            items: 2,
            dots: false,
            margin: 20
          },
          1024: {
            items: 3,
            dots: false,
            margin: 20
          },
      }
  });
}                                                  
